export enum PreviewDeviceType {
  Camera = 'camera',
  Microphone = 'microphone',
}

export enum PreviewErrorReason {
  DeviceInUse = 'device-in-use',
  PermissionDenied = 'permission-denied',
  DeviceNotFound = 'device-not-found',
  Unknown = 'unknown',
}

export interface PreviewError {
  device: PreviewDeviceType;
  reason: PreviewErrorReason;
}
